export default "__VITE_ASSET__BauEdeJI__"